<template>

  <el-popover
          :disabled="disabled"
          :placement="placement"
          width="200"
          trigger="hover">
    <div class="mini-keypad">

      <div class="digits-container">
        <el-input
          readonly
          v-model="number">
        </el-input>
      </div>

      <div class="keypad-layout" style="justify-content: flex-start">
        <div class="keypad-key dtmf-shortcut" v-show="showRecordingToggle">
          <el-tooltip placement="top" :content="recordingPaused ? 'Resume recording' : 'Pause recording'">
            <el-button @click="toggleRecording">
              <i v-if="recordingPaused" class="mdi mdi-record voxo-red" />
              <i v-else class="mdi mdi-pause-circle voxo-red" />
            </el-button>
          </el-tooltip>
        </div>
        <div class="keypad-key"></div>
        <div class="keypad-key"></div>
      </div>

      <div class="keypad-layout">
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('1')">
            <div class="button-number">
              1
            </div>
            <div class="button-letters">

            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('2')">
            <div class="button-number">
              2
            </div>
            <div class="button-letters">
              ABC
            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('3')">
            <div class="button-number">
              3
            </div>
            <div class="button-letters">
              DEF
            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('4')">
            <div class="button-number">
              4
            </div>
            <div class="button-letters">
              GHI
            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('5')">
            <div class="button-number">
              5
            </div>
            <div class="button-letters">
              JKL
            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('6')">
            <div class="button-number">
              6
            </div>
            <div class="button-letters">
              MNO
            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('7')">
            <div class="button-number">
              7
            </div>
            <div class="button-letters">
              PQRS
            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('8')">
            <div class="button-number">
              8
            </div>
            <div class="button-letters">
              TUV
            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('9')">
            <div class="button-number">
              9
            </div>
            <div class="button-letters">
              WXYZ
            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('*')">
            <div class="button-number">
              *
            </div>
            <div class="button-letters">

            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('0')">
            <div class="button-number">
              0
            </div>
            <div class="button-letters">

            </div>
          </el-button>
        </div>
        <div class="keypad-key">
          <el-button type="text" @click="keyPress('#')">
            <div class="button-number">
              #
            </div>
            <div class="button-letters">

            </div>
          </el-button>
        </div>
      </div>
    </div>
    <el-button style="width: 30px; height: 30px;" slot="reference" class="table-action-button icon-aqua" :disabled="disabled">
      <i class="mdi mdi-chevron-right"  style="font-size: 22pt;"/>
    </el-button>
  </el-popover>

</template>

<script>

  import {globalEventBus} from "@/globalEventBus";
  import {apiV2Host} from "@/feathers/feathers-client";

  export default {
    name: 'MiniKeypad',
    props: {
      channel: {required: true},
      sipHandle: {required: true},
      server: {required: true},
      disabled: {required: true},
      placement: {required: true, default: 'right'},
      callItem: {required: true}
    },
    data () {
      return {
        number: '',
        recordingPaused: false
      }
    },
    computed: {
      user(){
        return this.$store.state.auth.user;
      },
      isRecording() {
        if(this.sipHandle){
          const { recording } = this.sipHandle;
          this.recordingPaused = !recording;
          return recording;
        }
        return false;
      },
      showRecordingToggle() {
        if(this.callItem.direction === "initiator"){
          return this.user.myExtension.outboundRecord !== "no";
        }

        return this.sipHandle && this.sipHandle.canRecord;
      }
    },
    watch: {
      isRecording() {
        this.recordingPaused = !this.isRecording;
      }
    },
    methods: {
      keyPress(val){
        this.number = this.number + val;
        this.sendDTFM(val);
      },
      sendDTFM(val){
        this.$emit('sendDTMF', val);
      },
      async toggleRecording() {

        try {
          const response = await fetch(`${apiV2Host}/calling/recording/toggle`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              "Authorization": "Bearer " + this.$store.state.auth.accessToken,
            },
            body: JSON.stringify({
              callId: this.sipHandle.callId,
              recording: this.recordingPaused
            })
          });

          if(response.ok){
            this.recordingPaused = !this.recordingPaused
          }

        } catch (e) {
          console.log("toggle recording failed", e);
        }
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../../../../assets/scss/variables';

  .keypad-layout{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    >* {
      flex-basis: 30%;
    }
  }

  .keypad-key{
    text-align:center;
    margin: auto;
    width: 30px;
    flex-basis: 30%;
    .el-button--text {
      color: $text-color;
    }
    .el-button {
      padding: 8px;
    }
    i{
      font-size: 14pt;
    }
  }

  .keypad-btn {
    margin-left: auto;
  }

  .el-button {
    width: 40px;
    height: 40px;
  }

  .button-letters{
    font-size: 7pt;
    margin-top: 3px;
  }

  .digits-container{
    padding: 10px;
  }

  .digits-display{
    height: 30px;
    display: flex;
    padding: 0 10px;
    align-items: center;
  }

  .keypad-key.dtmf-shortcut {
    .el-button{
      padding: 0;
      width: 30px;
      height: 30px;
    }
  }

</style>
